import React from 'react'
import PropTypes from 'prop-types'
import UserTableHead from "./UserTableHead"
import UserTableList from "./UserTableList"
import {Spin} from "antd"

UserTable.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    users: PropTypes.array
}

function UserTable(props) {
    const {loading, error, users} = props

    return (
        <div className='UserLists'>
            <Spin spinning={loading}>
                <table>
                    <UserTableHead/>
                    <UserTableList {...props} users={users} error={error}/>
                </table>
            </Spin>
        </div>
    )
}

export default UserTable
